<form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
  <div class="d-flex justify-content-center">
    <div class="d-flex flex-column">
      <img class="profile-image mb-4" alt="profile-image" [src]="profileImageSrc" sizeMatch="height">
      <input #uploadButton type="file" id="profileImage" class="form-control" (change)="getImage($event)" accept=".png,.jpg" formControlName="profileImage" hidden />
      <button type="button" class="btn btn-outline-primary" (click)="uploadButton.click()">Upload photo</button>
    </div>
  </div>

  <hr>

  <div class="d-flex flex-fill justify-content-center">
    <button type="submit" class="btn btn-primary modal-btn mr-2" [disabled]="!formGroup.valid || isLoading">Submit</button>
    <button type="button" class="btn btn-secondary modal-btn" (click)="onDismiss()">Cancel</button>
  </div>
</form>

